module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"primary_offer_time":"PRIMARY OFFER TIME:","primary_offer_time_aria":"Countdown clock for allocation time remaining","offer_expires_in":"OFFER EXPIRES IN:"},"fr":{"primary_offer_time":"TEMPS D’OFFRE PRIMAIRE :","primary_offer_time_aria":"Compte à rebours pour le temps d’attribution restant","offer_expires_in":"L’OFFRE EXPIRE DANS :"}}')
  delete Component.options._Ctor
}
